import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { Account, AccountSaveResponse } from '../../../types/Account';
import { AxiosError } from 'axios';
import { mutationKeys } from '../mutationKeys';

export const postAccount = async (formData: AccountSaveResponse) => {
  const response = await CustomAxios.post(`accounts`, formData);
  const { data } = response;
  return data;
};

type useCreateAccountProps = {
  onSuccessCallback: (data: Account) => void;
};
export function useCreateAccount({ onSuccessCallback }: useCreateAccountProps) {
  return useMutation({
    mutationKey: [mutationKeys.createAccount],
    mutationFn: (formData: AccountSaveResponse) => postAccount(formData),
    onSuccess: (data: Account) => {
      // fetch the accounts again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allAccounts, 'new'] });

      // call success
      onSuccessCallback(data);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        // let set the query data with bad errored response
        const data: Account = err.response.data as Account;
        queryClient.setQueryData([queryKeys.allAccounts, 'new'], data);
      }
    },
  });
}
